@if (ready) {
    <div [innerHTML]="embedHtml | safe: 'html'"></div>
}
